import paymentSettingsService from '@/modules/paymentSettings/service/paymentSettingsService';

const state = {
  paymentSettings: {
    currency: 'USD', // Default currency
  },
  showChargeClientCardAlert: true,
  paymentGatewaysSettings: null,
  paymentMethods: null,
};

const getters = {
  paymentSettings: (state) => state.paymentSettings,
  currency: (state) => state.paymentSettings?.currency,
  taxMode: (state) => state.paymentSettings?.tax_mode,
  isPrimaryPaymentGatewayConnected: (state) => state.paymentSettings?.connected_payment_gateways?.includes(
    state.paymentSettings?.payments_gateway_type,
  ),
  isWalletConnected: (state) => state.paymentSettings?.connected_payment_gateways?.some((item) => item.includes('wallet_') || item.toLowerCase().includes('paypal')),
  // eslint-disable-next-line no-shadow
  isCheckoutEnabled: (state, getters) => getters.isPrimaryPaymentGatewayConnected || getters.isWalletConnected,
  showChargeClientCardAlert: (state) => state.showChargeClientCardAlert,
  isGatewayConnected: (state) => (gatewayType) => !!state.paymentSettings?.connected_payment_gateways?.find(
    (gatewayName) => gatewayName === gatewayType,
  ),
  paymentGatewaysSettings: (state) => state.paymentGatewaysSettings,
  paymentMethods: (state) => state.paymentMethods,
};

const mutations = {
  setPaymentSettings(state, paymentSettings) {
    state.paymentSettings = { ...state.paymentSettings, ...paymentSettings };
  },
  setShowChargeClientCardAlert(state, showChargeClientCardAlert) {
    state.showChargeClientCardAlert = showChargeClientCardAlert;
  },
  setPaymentGatewaysSettings(state, paymentGatewaysSettings) {
    state.paymentGatewaysSettings = paymentGatewaysSettings;
  },
  setPaymentMethods(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
};

const actions = {
  async fetchSettings({ commit, dispatch, rootGetters }) {
    const settings = await paymentSettingsService.fetchSettings();
    commit('setPaymentSettings', settings);
    const isGatewayPlatformEnabled = rootGetters['BusinessStore/hasFeature']('rollout.payments.gateway_platform');
    if (settings?.payments_gateway_type && isGatewayPlatformEnabled) {
      await dispatch(
        'fetchPaymentGatewaysSettings',
        settings.payments_gateway_type
      );
    }
  },
  async saveSettings({ commit }, settings) {
    const saveSettingsResponse = await paymentSettingsService.saveSettings({
      payment_settings: settings,
    });
    commit('setPaymentSettings', saveSettingsResponse.payment_settings);
  },
  async updateDefaultCurrency() {
    return paymentSettingsService.updateDefaultCurrency();
  },
  updateShowChargeClientCardAlert({ commit }, showChargeClientCardAlert) {
    commit('setShowChargeClientCardAlert', showChargeClientCardAlert);
  },
  async fetchPaymentGatewaysSettings({ commit }, gatewayName) {
    try {
      const { data } = await paymentSettingsService.fetchPaymentGatewaysSettings(gatewayName);

      const gateway = data?.payment_gateways?.[0] ?? null;
      const processingFeatures = gateway?.processing_features ?? null;
      const paymentMethods = gateway?.payment_methods ?? null;
  
      commit('setPaymentGatewaysSettings', processingFeatures);
      commit('setPaymentMethods', paymentMethods);
  
      return { processingFeatures, paymentMethods };
    } catch (error) {
      console.error(`[PaymentSettings] fetchPaymentGatewaysSettings failed (${gatewayName})`, error);
      commit('setPaymentGatewaysSettings', null);
      commit('setPaymentMethods', null);
      return { processingFeatures: null, paymentMethods: null };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
